import rangePickerOptions from './data/rangePickerOptions';
import hasPermission from './methods/hasPermission';
import filterEmptyField from './methods/filterEmptyField';
import formatter from './methods/formatter';
import parseRangeDate from './methods/parseRangeDate';
import fillDataStatistics from './methods/fillDataStatistics';
import convertQueryType from './methods/convertQueryType';
export default {
  install(Vue) {
    /* eslint-disable no-param-reassign */
    // Vue.isAuth = isAuth.methods.isAuth;
    // Vue.prototype.isAuth = isAuth.methods.isAuth;
    // Vue.filterEmptyField = filterEmptyField.methods.filterEmptyField;
    // Vue.prototype.filterEmptyField = filterEmptyField.methods.filterEmptyField;
    // Vue.parseRangeDate = parseRangeDate.methods.parseRangeDate;
    // Vue.prototype.parseRangeDate = parseRangeDate.methods.parseRangeDate;

    Vue.mixin(rangePickerOptions);
    Vue.mixin(hasPermission);
    Vue.mixin(formatter);
    Vue.mixin(parseRangeDate);
    Vue.mixin(filterEmptyField);
    Vue.mixin(fillDataStatistics);
    Vue.mixin(convertQueryType);
  },
};
